<template>
    <div>
        <h2 class="font-fjalla-one text-4xl font-normal uppercase">
            {{ $t('8select.recommendations.titleSimilar') }}
        </h2>
        <EightSelectRecommendations
            v-if="productId"
            :product-ids="[productId]"
            :product-qty="{ value: '6', source: 'value' }"
            item-list-id="8select_recommendations_pdp"
            item-list-name="8select Product Detail Recommendations"
            title=""
        />
    </div>
</template>

<script setup lang="ts">
interface Props {
    content?: {
        config?: Record<string, unknown>
    }
}

defineProps<Props>()

const { product } = useProduct()

// Product number (SKU) for 8select API. Two hooks can signal a color change:
// - productGalleryDataChanged: swatch option picked while the configuration is still
//   incomplete (same signal the media gallery uses).
// - productVariantChanged: the configuration just became complete - only relevant here if
//   the option that completed it was itself a swatch option (changedGroupIsSwatch), since
//   productGalleryDataChanged is skipped in that case.
const productId = ref<string | null>(product?.value?.productNumber || null)

useRuntimeHook('productGalleryDataChanged', ({ data }) => {
    productId.value = data.productNumber || null
})

useRuntimeHook('productVariantChanged', ({ data, changedGroupIsSwatch }) => {
    if (!changedGroupIsSwatch) {
        return
    }

    productId.value = data.productNumber || null
})
</script>
